import Image from 'next/image';
import { cn } from '@/lib/utils';

/**
 * Gravlon Technologies brand wordmark sourced from the live site at
 * https://gravlontechnologies.com/assets/img/gravlon-logo.svg
 * (the SVG wraps a base64 PNG, so we render it as an image, not inline SVG).
 *
 * The asset was authored for a light background. On our dark hero we invert
 * its luminance via the `brightness(0) invert(1)` filter pair, then add a
 * small pulsing brand-accent dot that doubles as a "system is live" signal.
 *
 * Pure RSC; the pulse is a CSS animation, no client JS.
 */
export function Logo({ className }: { className?: string }) {
  return (
    <span
      className={cn('inline-flex items-center gap-2.5', className)}
      aria-label="Gravlon Technologies"
    >
      <Image
        src="/gravlon-logo.svg"
        alt=""
        width={366}
        height={105}
        priority
        unoptimized
        className="h-10 w-auto select-none [filter:brightness(0)_invert(1)] sm:h-11"
      />
      <span
        aria-hidden="true"
        className="relative inline-block h-1.5 w-1.5"
      >
        <span className="absolute inset-0 rounded-full bg-(--color-accent)" />
        <span className="pulse-dot-anim absolute inset-0 rounded-full bg-(--color-accent)" />
      </span>
    </span>
  );
}
